<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Q5ljlJ/tc-custom/9781418557720.jpg?1708485322636" alt="This image is the cover for the book Checklist for Life: The Ultimate Handbook"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Checklist for Life: The Ultimate Handbook
      </h1>
      <p class="bookDescription body article font2">
        <p><i>Checklist for Life</i> is the ultimate handbook for living a successful, joy-filled life. In addition to a brief narrative, each chapter of this interactive handbook contains:</p>An "I Will" checklist of heart and attitude reinforcementsA "Things to Do" checklist of action pointsA "Things to Remember" section of Scripture verses and applicable quotes from famous and not-so-famous people.<p>Topics addressed include everyday miracles, prayer, purpose, and relationships.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        GRQ Ink, Inc
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Thomas Nelson
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?20be7e28